// src/data/resumeData.js

export const workExperience = [
  {
    company: '주식회사 유리원',
    period: '23.04 - 24.03, 25.03 - 25.06',
    
    roles: [
      {
        title: 'UI/UX 기획 · 프론트엔드 기반 웹 구축',
        description: [
          '기업 웹사이트 기획부터 구현까지 전 과정 수행 (브랜딩 ·UX·퍼블리싱)',
          'ChatGPT 기반 기획 문서 정리 및 화면 구조 개선',
          '기획-디자인-개발 산출물 작성 과정에 AI 활용',
          'HTML/CSS 기반 반응형 웹 구조 설계 및 구현',
          '서비스 IA 설계 및 사용자 흐름 정리',
          '메타 태그 및 검색 구조 최적화 작업 수행',
          '주요 포털 검색 결과 1페이지 노출 달성',
        ],
      },
    ],
  },
  {
    company: 'STT Trading Co. (Freelance)',
    period: '21.12 - 22.02',
    roles: [
      {
        title: 'UI/UX 설계 및 웹 프로젝트 수행',
        description: [
          '웹 서비스 구조 설계 및 화면 기획',
          'HTML/CSS 기반 반응형 웹 구조 설계 및 구현',
          '사용자 여정 기반 화면 구조 설계',
          '클라이언트 요구사항 분석 및 기능 정의',
        ],
      },
    ],
  },
  {
    company: '주식회사 로브',
    period: '18.01 - 21.03',
    roles: [
      {
        title: 'IT 기획 · 프로젝트 총괄',
        description: [
          'IT 인프라 및 시스템 개선 프로젝트 기획 및 운영',
          '외주 개발사 발주 및 일정·산출물 관리',
          '관리자 페이지 기능 정의 및 구조 설계',
          '내부 업무 프로세스 개선 및 운영 체계 문서화',
        ],
      },
      {
        title: 'IT 기획 · 공공 프로젝트 PM',
        description: [
          '나라장터 입찰 공고 분석 및 사업 기회 발굴',
          '제안 전략 수립 및 제안서 작성',
          '공공 IT 프로젝트 입찰부터 운영까지 전 과정 관리',
          '프로젝트 범위 정의 및 리스크 관리',
          '협업 구조 조율 및 일정 통제',
        ],
      },
    ],
  },
  {
    company: 'STT Trading Co.',
    period: '16.09 - 17.11',
    roles: [
      {
        title: '온라인 쇼핑몰 운영 및 관리',
        description: [
          '쇼핑몰 운영 및 상품/콘텐츠 관리',
          '소셜 미디어 채널 운영 및 프로모션 수행',
        ],
      },
    ],
  },
  {
    company: '(주)KR창업',
    period: '08.06 - 16.05',
    roles: [
      {
        title: '웹사이트 운영 및 관리',
        description: [
          '웹사이트 운영 및 개선',
          '광고 신규 사업 및 기획',
        ],
      },
    ],
  },
  
];

export const education = [
  {
    title: '그린컴퓨터아트학원  종로',
    period: '25.08 - 26.02',
    lines: [
      '[프로젝트기반]프론트엔드 개발자 양성',
      'Figma/React/Next.js/PHP/Mysql/chatGPT',
      'Figma / AI 도구를 활용한 prototype 제작',
    ],
  },
  {
    title: '이젠아카데미평생교육원',
    period: '22.10 - 23.01',
    lines: [
      '피그마(figma) UIUX 웹&앱 디자인',
      'Figma',
    ],
  },
  {
    title: '(사)구로여성인력개발센터',
    period: '22.04 - 22.07',
    lines: [
      '웹&앱 트렌드 디자인 과정 이수',
      'Photoshop/Illustrator/XD',
    ],
  },
  {
    title: '안양 그린컴퓨터',
    period: '21.04 - 21.09',
    lines: [
      '[플립드러닝] 스마트 UI/UX 양성과정 이수',
      '웹디자인/웹퍼블리셔',
    ],
  },
  {
    title: '한국소프트웨어 인재개발원',
    period: '19.05 - 19.06',
    lines: [
      'UIUX 실무활용',
    ],
  },
  {
    title: '계명대학교 건축공학과 졸업',
    period: '93.03 - 97.02',
    lines: [],
  },
];

export const certificates = [
  {
    title: '웹디자인 개발 기능사',
    year: '22.04',
  },
];